define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"./StyleAttributeId"
], function(declare,_,StyleAttributeId) {

	return declare(StyleAttributeId, {

		sourceClassName: "ColorColorwayContext",
		destinationClassNames: ["Colorway","ColorwayAttributes"]

	});
});
